import React from "react";
import {
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Box,
  IconButton,
  Divider,
  ListItemButton,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import ExploreIcon from "@mui/icons-material/Explore";
import AddIcon from "@mui/icons-material/Add";
import MenuIcon from "@mui/icons-material/Menu";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";

interface SidebarProps {
  isOpen: boolean;
  toggleSidebar: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();

  const handleEditClick = () => {
    navigate("/chat");
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="100vh"
      bgcolor="#f5f5f5"
      sx={{ transition: "width 0.3s", width: isOpen ? "240px" : "0px" }}
    >
      <Box
        width="100%"
        bgcolor="#f5f5f5"
        height="100vh"
        overflow="hidden"
        display={isOpen ? "block" : "none"}
      >
        <List>
          <ListItem>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
            >
              <IconButton edge="start" color="inherit" onClick={toggleSidebar}>
                <MenuIcon />
              </IconButton>
              <IconButton color="inherit" onClick={handleEditClick}>
                <EditIcon />
              </IconButton>
            </Box>
          </ListItem>

          <ListItemButton>
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary="Home" />
          </ListItemButton>
          <ListItemButton>
            <ListItemIcon>
              <ExploreIcon />
            </ListItemIcon>
            <ListItemText primary="Explore GPTs" />
          </ListItemButton>
        </List>
        <Divider />
      </Box>
      <Box
        width="100%"
        overflow="hidden"
        p={2}
        display={isOpen ? "block" : "none"}
      >
        <ListItemButton>
          <ListItemIcon>
            <AddIcon />
          </ListItemIcon>
          <ListItemText primary="Add Team workspace" />
        </ListItemButton>
      </Box>
    </Box>
  );
};

export default Sidebar;
